<template><ListFilter field="other_lab_data" :options="opts" label="Другие лабораторные данные" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'OtherLabDataFilter', components:{ListFilter}, data(){ return { opts:['Капиллярометрия','Шлифы (фото и описание)','SEM','ФЕС','Фото керна','Фото лаб. образцов','3Д-фото','КТ на второй энергии'] } } }
</script>
